/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description Helper function to filter similar listings
 */

import type { Listable as ListableType } from '@zcode/state-type'
import Listable from '../bizos/listable'

interface filterSimilarListingsProps {
  displayLimit: number
  includeIncomeRestricted: unknown
  similar: readonly ListableType[]
}

export const filterSimilarListings = ({
  similar,
  displayLimit,
  includeIncomeRestricted,
}: filterSimilarListingsProps) => {
  const duplicates = new Set<ListableType['uId']>()
  const filtered: ListableType[] = []
  // extract out relevant listings for multi messaging form
  if (similar.length) {
    let i = 0
    const limit = Math.min(displayLimit, similar.length)
    while (filtered.length < limit && i < similar.length) {
      const listable = similar[i]
      if (
        !duplicates.has(listable.uId) &&
        listable.isMessageable &&
        (!listable.isIncomeRestricted || includeIncomeRestricted)
      ) {
        duplicates.add(listable.uId)
        filtered.push(new Listable({ ...listable._data, multi_message_selected: true }))
      }
      i += 1
    }
  }
  return filtered
}
